"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var useComponent_exports = {};
__export(useComponent_exports, {
  useComponent: () => useComponent
});
module.exports = __toCommonJS(useComponent_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react = require("react");
var NavigationContent = function NavigationContent2(param) {
  var { render, children } = param;
  return render(children);
};
function useComponent(render) {
  var renderRef = (0, import_react.useRef)(render);
  renderRef.current = render;
  (0, import_react.useEffect)(function() {
    renderRef.current = null;
  });
  return (0, import_react.useRef)(/* @__PURE__ */ (0, import_react.forwardRef)(function(param, _ref) {
    var { children } = param;
    var _$render = renderRef.current;
    if (_$render === null) {
      throw new Error("The returned component must be rendered in the same render phase as the hook.");
    }
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(NavigationContent, {
      render: _$render,
      children
    });
  })).current;
}
//# sourceMappingURL=useComponent.js.map
